import React from 'react';
import { SectionLabel } from 'nelitomorphism';
import { EMAIL } from './Contact';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-info">
            <h3 className="footer-name">NLTW</h3>
            <p className="footer-description">
              Nelito Junior. Full-stack engineer building blockchain
              infrastructure at Fuel Network.
            </p>
          </div>
          <div className="footer-links">
            <div>
              <SectionLabel>Navigation</SectionLabel>
              <ul className="footer-nav">
                <li><a href="#about">About</a></li>
                <li><a href="#experience">Experience</a></li>
                <li><a href="#skills">Stack</a></li>
                <li><a href="#education">Education</a></li>
                <li><a href="#activity">Activity</a></li>
              </ul>
            </div>
            <div>
              <SectionLabel>Connect</SectionLabel>
              <ul className="footer-nav">
                <li><a href={`mailto:${EMAIL}`}>Email</a></li>
                <li><a href="https://github.com/nelitow" target="_blank" rel="noopener noreferrer">GitHub</a></li>
                <li><a href="https://www.linkedin.com/in/nelito-jr-76b349240/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">© {currentYear} NLTW</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
